import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

// Scrolls to a homepage section, or navigates home first when on another page
export const useSectionNavigator = () => {
  const navigate = useNavigate();

  return useCallback((id, delay = 0) => {
    const element = document.getElementById(id);
    if (!element) {
      navigate(`/#${id}`);
      return;
    }
    const scroll = () => element.scrollIntoView({ behavior: 'smooth' });
    if (delay) setTimeout(scroll, delay);
    else scroll();
  }, [navigate]);
};
